import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function cadastroterminal(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@cadastroterminal/FIND_CADASTROTERMINAL':
      case '@cadastroterminal/UPDATE_CADASTROTERMINAL':
      case '@cadastroterminal/DELETE_CADASTROTERMINAL':
      case '@cadastroterminal/STORE_CADASTROTERMINAL':
      case '@cadastroterminal/CADASTROTERMINAL_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@cadastroterminal/SUCCESS_REMOVE':
      case '@cadastroterminal/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@cadastroterminal/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.cadastroterminal;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@cadastroterminal/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.cadastroterminal;
        break;
      }

      case '@cadastroterminal/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
